module.exports = __webpack_public_path__ + "static/media/clock.4c966442.svg";